export let RelativeSelectionPos = /*#__PURE__*/function (RelativeSelectionPos) {
  RelativeSelectionPos["Before"] = "Before";
  RelativeSelectionPos["Start"] = "Start";
  RelativeSelectionPos["Inside"] = "Inside";
  RelativeSelectionPos["End"] = "End";
  return RelativeSelectionPos;
}({});